import styled from 'styled-components';

// CONSTANTS
import { theme } from '../../constants/theme';
import { responsiveEndPoints } from '../../constants/responsive-endpoints';

export const Container = styled.div`
  justify-content: start;
  background: ${theme.colors.primary.white};
  box-shadow: 0px -1px 0px rgba(0, 0, 0, 0.03);
  min-height: 100px;
  padding: 24px 30px 24px 104px;
  position: fixed;
  bottom: 0;
  width: calc(100% - 354px - 300px);

  @media (max-width: 1360px) {
    width: calc(100% - 354px - 100px);
  }

  @media (max-width: 1280px) {
    width: calc(100% - 286px - 100px);
  }

  @media (max-width: ${responsiveEndPoints.mobile}px) {
    width: 100vw;
    padding: 24px 16px 16px;
  }
`;

export const ContainerButton = styled.div`
  display: flex;

  > button {
    width: 209px;
    + button {
      margin-left: 24px;
    }
  }
`;
